import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserRolesService } from '@bp-core/src/lib/services/portal/user-roles.service';
import { SudoAccessDeferral } from 'bp/shared/guards/sudo-access.guard';

/** Roles que pueden abrir la forense del núcleo de agentes (lectura cross-cliente, 048 US3). */
export const AGENT_FORENSICS_ROLES = ['ia-manager', 'sudo'] as const;

/** Puede abrir la forense con estos roles. */
export function canOpenAgentForensics(roles: readonly string[]): boolean {
  return AGENT_FORENSICS_ROLES.some(r => roles.includes(r));
}

/**
 * Guard de `/ia/forense`: `ia-manager` o `sudo` (el mismo `[Authorize(Roles = "ia-manager, sudo")]` del servicio
 * `AiAgentAdminGrpcService`). A diferencia de `IaManagerGuard`, `sudo` sin `ia-manager` entra: la forense es la
 * herramienta de soporte para revisar lo que el asistente le respondió a un cliente. El resto de `/ia` sigue siendo
 * exclusivo de `ia-manager`.
 *
 * En una carga directa, mientras los permisos del sudo no llegan, cede el paso: el layout revalida la URL con los
 * permisos y lleva a la persona a su inicio (feature 057, H4), igual que `IaManagerGuard`.
 */
@Injectable({ providedIn: 'root' })
export class AgentForensicsGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly roles = inject(UserRolesService);
  private readonly deferral = inject(SudoAccessDeferral);

  canActivate(): boolean | UrlTree {
    if (canOpenAgentForensics(this.roles.roles()) || this.deferral.isDeferred()) return true;
    return this.router.parseUrl('/errors/401');
  }
}
